<template>
  <layout :drawer="false">

    <template slot="nav">
      <router-link class="cursor-pointer" :to="{ name: 'Workshop'}">
        <v-icon>mdi-chevron-left</v-icon>
        <v-icon>mdi-human-male-board-poll</v-icon>
      </router-link>
    </template>

    <template slot="nav-tools">
      <smart-btn v-if="isLocked" class="mr-2" disabled >
        <v-icon>mdi-trackpad-lock</v-icon>
        <span class="pl-1">Workshop clos</span>
      </smart-btn>
      <smart-btn v-else @click.native="onWorkshopFinish"  class="mr-2">
        <v-icon>mdi-human-male-board-poll</v-icon>
        <span class="pl-1">Clore le workshop</span>
      </smart-btn>
    </template>

    <template slot="content">
      <v-container fluid>
        <!-- WShopDetails_INFOS -->
            <v-container fluid class="px-4 blue-grey lighten-1 workshop-header" >
              <v-row dense class="d-flex align-stretch">
                <v-col cols="4">
                    <p class="headline blue-grey--text text--lighten-4">Workshop  <span v-if="workshop.startDate">du {{_convertDay(workshop.startDate)}}</span></p>
                    <div class="d-flex align-center">
                      <p class=" white--text text-truncate" style="font-size: 18px;" >{{ workshop.place }}</p>
                      <v-btn icon small color="white" @click="edit" class="ml-1">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                      <StatusChip class="ml-4" small :value="workshop.status" />
                    </div>
                </v-col>
                <v-col cols="8" class="" >
                  <v-row dense class="align-stretch h-100">
                    <v-col cols="3" class="pa-0 pt-2 d-flex flex-column align-start">
                      <p v-if="workshop.cost || workshop.cost === 0" class="caption blue-grey--text text--lighten-4">
                        Coût
                        <span class="ml-4 caption white--text">{{getCost}}</span>
                      </p>
                      <div>
                        <p class="caption blue-grey--text text--lighten-4">
                          Début
                          <span class="ml-2 font-weight-medium white--text">{{_convertDay(workshop.startDate)}}</span>
                          à
                          <span class="font-weight-medium white--text">{{_convertHour(workshop.startDate)}}</span>
                        </p>
                        <p v-if="workshop.stopDate" class="caption blue-grey--text text--lighten-4">
                          Clôture
                          <span class="font-weight-medium white--text">{{_convertDay(workshop.stopDate)}}</span>
                          à
                          <span class="font-weight-medium white--text">{{_convertHour(workshop.stopDate)}}</span>
                        </p>
                      </div>
                    </v-col>

                    <v-col cols="1"/>

                    <v-col cols="8" class="pa-0 d-flex align-center justify-space-between">
                      <div>
                        <p v-if="workshop.comment" class="caption blue-grey--text text--lighten-4">
                          Commentaire global
                        </p>
                        <div class="workshop-comment caption white--text">
                          {{workshop.comment}}
                        </div>
                      </div>
                      <div v-if="workshop.status !== 'closed'" class="ml-4 cursor-pointer" @click="toggleInfos">
                        <v-chip small class="cursor-pointer">
                          <v-icon small :color="showInfos ? 'blue darken-2' : 'grey darken-1'" class="mr-1">mdi-information-slab-box</v-icon>
                          <p class="caption" :class="showInfos ?'blue--text text--darken-2' : 'grey--text text--darken-1'">Aide</p>
                        </v-chip>
                      </div>
                    </v-col>

                  </v-row>
                </v-col>
              </v-row>
            </v-container>

        <!-- WShopDetails_Meets + WShopDetails_SmartAgentSearch -->
        <v-container fluid  ref="workshopBody" class="workshop-body d-flex justify-space-between pa-0 mx-0" :style="workshopBodyStyle">
            <div class="panel-left d-flex flex-column panel-left-header">
              <div class="d-flex justify-space-between align-center">
                <v-subheader class="title">Liste des sessions</v-subheader>

                <div v-if='!isLocked' class="ml-4 cursor-pointer" @click="newMeet">
                  <v-chip small class="cursor-pointer">
                    <v-icon small color="grey darken-1">mdi-plus</v-icon>
                    Nouvelle session
                  </v-chip>
                </div>
              </div>

              <v-card class="elevation-1 pa-4 meet-list-card">
                <div class="meet-list-table-scroll">
                  <v-data-table :headers="meetsHeaders"
                    :items="meets"
                    :sort-by="['creationDate']"
                    :sort-desc="[false]"
                    :disable-pagination="true"
                    :hide-default-footer="true"
                    class="elevation-0 tbl table"
                    :item-class="getRowClass"
                    no-data-text="Aucune rencontre."
                    @click:row="(meet) => onMeetClick(meet)"
                >
                  <template #header.userId="{ header }">
                  <span class="pl-1">
                    {{ header.text }}
                  </span>
                  </template>
                  <template #item.creationDate="{ value }">
                    <span class="caption grey--text">
                      {{ _convertHour(value) }}
                    </span>
                  </template>
                  <template #item.userId="{ item }">
                    <span class="pl-1">{{ item | fullname(true, true) }}</span>
                  </template>
                  <template #item.contactCount="{ item }">
                    <span>{{ contactsMap[item.id].length }}</span>
                  </template>

                  <template #item.actions="{ item }">
                    <v-row no-gutters justify="end" class="pr-4">
                      <v-icon small @click.stop="deleteMeet(item)">delete</v-icon>
                    </v-row>
                  </template>
                </v-data-table>
                </div>
              </v-card>
            </div>

            <div class="panel-right d-flex flex-column">
                <div class="d-flex align-center">
                  <v-subheader class="title">
                    <template v-if="selected.displayContacts && selected.meet.id !== null">
                      Session de
                      {{_convertHour(selected.meet.creationDate)}}
                    </template>
                    <template v-else-if="!isLocked">
                      Nouvelle Session
                    </template>
                  </v-subheader>

                  <div v-if="selected.displayContacts && selected.meet.id !== null && !selected.isSearchActive && !isLocked"
                      class="ml-4 cursor-pointer"
                      @click="newContact"
                  >
                    <v-chip small class="cursor-pointer">
                      <v-icon small color="grey darken-1">mdi-plus</v-icon>
                      Nouveau participant
                    </v-chip>
                  </div>
                </div>

                <SmartAgentSearch
                    v-if="!isLocked"
                    ref="smartAgentSearch"
                    :selected-contacts="contactsMap[selected.meet.id] || []"
                    :workshop-id="workshopId"
                    :show-infos="showInfos"
                    @update:activity="onSearchActivity"
                    @selected="handleSelect"
                    @unselected="handleUnselect"
                    @close-infos="showInfos = false"
                />

              <v-card v-if="selected.displayContacts && selected.meet.id !== null && !selected.isSearchActive &&!showInfos"
                  class="elevation-1 contact-list-card d-flex flex-column"
              >
                <MeetContactsList
                    class="pa-4 meet-contacts-list-grow"
                    :value="contactsMap[selected.meet.id] || []"
                    :isLocked="isLocked"
                    @contacts-updated="fetchContacts"
                    @edit-agency="editAgencyContacts"
                />
                <MeetTexts
                    :key="selected.meet.id"
                    :value="selected.meet"
                    @texts-updated="fetchMeets"
                />
              </v-card>
            </div>

        </v-container>

        <WorkshopFinishDialog v-model="finish.dialog"
            :unvalid-contacts="unvalidContacts"
            :checked-list="finish.checkedList"
            :can-finish-workshop="canFinishWorkshop"
            :finish="finish"
            @save-contact="updateCurrentUnvalid"
            @confirm="finishWorkshop"
        />

        <!-- EDIT WORKSHOP DIALOG -->
        <WorkshopEditDialog
            v-if="edition.dialog"
            v-model="edition.dialog"
            :workshop="edition.workshop"
            context="EDIT"
            @saved="fetchWorkshop"
        />

      </v-container>

    </template>
  </layout>
</template>

<script>
import Layout from "@/views/Layout.vue"
import { get, post } from "@/utils/api"
import FormMixin from "@/components/mixins/FormMixin"
import MeetContactsList from "@/views/hlagons/workshop/MeetContactsList.vue"
import MeetTexts from "@/views/hlagons/workshop/MeetTexts.vue"
import { EventBus } from "@/components/commons/event-bus"
import SmartAgentSearch from "@/components/commons/SmartAgentSearch.vue"
import WorkshopFinishDialog from "@/views/hlagons/workshop/WorkshopFinishDialog.vue"
import StatusChip from "@/components/commons/StatusChip.vue";
import WorkshopEditDialog from "@/views/hlagons/workshop/WorkshopEditDialog.vue";

export default {
  name: "WorkshopDetails",
  mixins: [FormMixin],
  components: {
    WorkshopEditDialog,
    StatusChip,
    WorkshopFinishDialog,
    SmartAgentSearch,
    MeetTexts,
    MeetContactsList,
    Layout
  },
  props: {
    workshopId: {
      type: String,
      required: true
    }
  },
  emits: ['input'],
  data: () => ({
    fetchData: {
      loading: false,
      noFetchYet: true
    },
    workshopBodyHeight: null,
    workshop: {
      id: null,
      place: "",
      userId: null,
      status: "",
      comment: "",
      cost: null,
      startDate: null,
      stopDate: null
    },
    meets: [],
    workshopContacts: [],
    selected: {
      isSearchActive: false,
      displayContacts: false,
      meet: {
        id: null,
        workshopId: null,
        userId: null,
        comment: "",
        todoNote: "",
        creationDate: "2026-01-01T10:00:00.000"
      }
    },
    edition: {
      dialog: false,
      workshop: null,
    },
    finish: {
      dialog: false,
      checkedList: [],
      inProgress: false,
      done: false,
      errors: [],
    },
    showInfos: false,
  }),
  created() {
    this.init()
  },
  mounted() {
    this.updateWorkshopBodyHeight()
    window.addEventListener("resize", this.updateWorkshopBodyHeight)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWorkshopBodyHeight)
  },
  watch: {
    workshop: {
      deep: true,
      handler() {
        this.updateWorkshopBodyHeight()
      }
    },
    'selected.displayContacts'() {
      this.updateWorkshopBodyHeight()
    },
    'selected.isSearchActive'() {
      this.updateWorkshopBodyHeight()
    },
    'selected.meet.id'() {
      this.updateWorkshopBodyHeight()
    }
  },
  computed: {
    contactsMap() {
      const map = {}

      this.meets.forEach(meet => {
        map[meet.id] = []
      })

      this.workshopContacts.forEach(contact => {
        if (map[contact.meetId]) {
          map[contact.meetId].push(contact)
        }
      })

      return map
    },
    unvalidContacts() {
      return this.workshopContacts
          .filter(c => !this.contactCheck(c) || this.finish.checkedList.includes(c.id))
          .sort((a, b) => a.id - b.id)
    },
    canFinishWorkshop() {
      if (this.finish.inProgress || this.finish.done) {
        return false
      }
      return this.workshopContacts.every(contact => this.contactCheck(contact))
    },
    isLocked() {
      return this.workshop.status === 'closed'
    },
    selectedMeetId() {
      return this.selected.meet?.id
    },
    meetsHeaders() {
      const base = [
        { text: "Hôte", align: "center", value: "userId"},
        {
          text: "Heure", value: "creationDate", align: "left",
          sortable: true, sort: (a, b) => new Date(a) - new Date(b)
        },
        {text: "Participants", align: "center", value: "contactCount", sortable: false},
      ]

      if (!this.isLocked) {
        base.push({text: "Actions", align: "right", value: "actions"})
      }

      return base
    },
    workshopBodyStyle() {
      return this.workshopBodyHeight ? { height:`${this.workshopBodyHeight}px`} : {}
    },
    getCost() {
      if (!this.workshop.cost && this.workshop.cost !== 0) {
        return ""
      }
      const formated = String(this.workshop.cost).replace(".", ",")
      return `${formated} €`
    },
  },
  methods: {
    init() {
      this.fetchData.loading = true

      Promise.all([
        get(`/api/workshop/${this.workshopId}`).json(),
        get(`/api/workshop/${this.workshopId}/meet`).json(),
        get(`/api/workshop/${this.workshopId}/contacts`).json()
      ])
          .then(([workshop, meets, contacts]) => {
            this.workshop = workshop
            this.meets = meets
            this.workshopContacts = contacts
          })
          .finally(() => {
            this.fetchData.noFetchYet = false
            this.fetchData.loading = false
            this.updateWorkshopBodyHeight()
          })
    },
    edit() {
      this.edition.workshop = { ...this.workshop }
      this.edition.dialog = true
    },
    async fetchContacts() {
      const contacts = await get(`/api/workshop/${this.workshopId}/contacts`).json()
      this.workshopContacts = [...contacts]
    },
    async fetchMeets() {
      const meets = await get(`/api/workshop/${this.workshopId}/meet`).json()
      this.meets = [...meets]
    },
    async fetchWorkshop() {
      const workshop = await get(`/api/workshop/${this.workshopId}`).json()
      this.workshop = {...workshop}
    },
    onMeetClick(meet) {
      this.selected.meet = {...meet}
      this.selected.displayContacts = true
      this.showInfos = false
      if (this.$refs.smartAgentSearch) {
        this.$refs.smartAgentSearch.reset()
      }
    },
    getRowClass(item) {
      return item.id === this.selectedMeetId ? 'selected-row' : ''
    },
    deleteMeet(meet) {
      if (this.isLocked) {
        return
      }
      const contacts = this.contactsMap[meet.id] || []

      if (contacts.length === 0) {
        post(`/api/workshop/${this.workshopId}/meet/${meet.id}/delete`)
            .res(() => {
              const index = this.meets.findIndex((m) => m.id === meet.id)
              if (index !== -1) this.meets.splice(index, 1)
              this.unselectMeet()
            })
      } else {
        this.$root
            .$confirm(
                this.$t("confirm"),
                `Confirmer la suppression de cette session ainsi que de ${contacts.length === 1 ? "son contact" : "ses " + contacts.length + " contacts"} ?`,
                {width: 450}
            )
            .then((confirm) => {
              if (!confirm) {
                return Promise.resolve()
              }

              return post(`/api/workshop/${this.workshopId}/meet/${meet.id}/delete`)
                  .badRequest((err) => {
                    EventBus.$emit("toaster-msg", err.toString())
                  })
                  .res(() => {
                    const index = this.meets.findIndex((m) => m.id === meet.id)
                    if (index !== -1) this.meets.splice(index, 1)
                    this.unselectMeet()
                  })
            })
      }
    },
    async newMeet() {
      if (this.isLocked) { return null }
      if (!await this.confirmWorkshopStartIfNeeded()) return null

      const payload = {
        workshopId: this.workshopId,
        userId: this.currentUser.id
      }

      const response = await post(`/api/workshop/${this.workshopId}/meet`, payload).json()
      const { needRefresh, ...meetRaw } = response
      const meet = {...meetRaw, lastname:this.currentUser.name }
      this.meets = [...this.meets, meet]
      this.onMeetClick(meet)

      if (needRefresh) {
        this.init()
      }
      return meet
    },
    newContact() {
      this.selected.isSearchActive = true
      if (this.$refs.smartAgentSearch) {
        this.$refs.smartAgentSearch.focusSearchBar()
      }
    },
    onSearchActivity(isActive) {
      this.selected.isSearchActive = isActive
    },
    editAgencyContacts(agencyId) {
      if (this.$refs.smartAgentSearch) {
        this.$refs.smartAgentSearch.onSelectAgency({id: agencyId})
      }
    },
    async handleSelect(elements) {
      if (this.isLocked) {
        return
      }

      const meet = this.selected.meet.id ? this.selected.meet : await this.newMeet()
      if (!meet) {
        return
      }

      const payload = elements.map((e) => ({
        workshopId: this.workshopId,
        meetId: meet.id,
        agentId: e.agentId,
        agencyId: e.agencyId,
        agencyName: e.agencyName,
        firstname: e.firstname,
        lastname: e.lastname,
        email: e.email
      }))

      await post(`/api/workshop/${this.workshopId}/contact/${meet.id}`, payload)
          .badRequest((err) => {
            EventBus.$emit("toaster-msg", err.toString())
          })
          .res(() => {
            this.fetchContacts()
          })
    },
    handleUnselect(elements) {
      const payload = elements.map(e => e.id)

      return post(`/api/workshop/${this.workshopId}/contact/${this.selected.meet.id}/delete`, payload)
          .badRequest((err) => {
            EventBus.$emit("toaster-msg", err.toString())
          })
          .res(() => {
            this.fetchContacts()
          })
    },
    unselectMeet() {
      this.selected.displayContacts = false
      this.selected.meet = {
        isSearchActive: false,
        displayContacts: false,
        meet: {
          id: null,
          workshopId: null,
          userId: null,
          comment: "",
          todoNote: "",
          creationDate: "2026-01-01T10:00:00.000"
        }
      }
    },
    contactCheck(contact) {
      if (contact.agencyId && contact.agentId) {
        return true
      }

      if (contact.agencyId) {
        return (
            contact.firstname && contact.firstname.trim().length > 0 &&
            contact.lastname && contact.lastname.trim().length > 0 &&
            contact.email && contact.email.trim().length > 0
        )
      }

      return false
    },
    async updateCurrentUnvalid(payload) {
      await post(`/api/workshop/${this.workshopId}/contact/${payload.meetId}/${payload.id}`, payload)
          .badRequest((err) => {
            EventBus.$emit("toaster-msg", err.toString())
          })
          .res(async () => {
            if (!this.finish.checkedList.includes(payload.id)) {
              this.finish.checkedList.push(payload.id)
            }

            await this.fetchContacts()
          })
    },
    onWorkshopFinish() {
      if (this.isLocked) {
        return
      }
      this.finish.dialog = true
    },
    async finishWorkshop() {
      if (this.isLocked) {
        return
      }
      this.finish.inProgress = true

      post(`/api/workshop/${this.workshopId}/close`)
          .badRequest(err => {
            EventBus.$emit("toaster-error", err.message);
          })
          .json()
          .then((errorReports) => {
            this.finish.errors = errorReports
            this.finish.done = true
            this.fetchWorkshop()
          })
    },
    async confirmWorkshopStartIfNeeded() {
      if (this.workshop.status !== 'not_started') return true
      const confirm = await this.$root.$confirm(
          this.$t("confirm"),
          "Créer la première session va démarrer le workshop. Voulez-vous continuer ?",
          {width: 500}
      )
      if (!confirm) return false
      if (!this.workshop.startDate) return true

      const startDate = new Date(this.workshop.startDate)

      if (startDate > new Date()) {
        const confirmAdvance = await this.$root.$confirm(
            this.$t("confirm"),
            `Attention, la date de début du workshop était initialement prévue le ${this._convertDay(this.workshop.startDate)} à ${this._convertHour(this.workshop.startDate)} et va être avancée à maintenant.`,
            {width: 500}
        )

        if (!confirmAdvance) return false
      }

      return true
    },
    updateWorkshopBodyHeight() {
      this.$nextTick(() => {
        const ref = this.$refs.workshopBody
        const el = ref && ref.$el ? ref.$el : ref

        if (!el || !el.getBoundingClientRect) { return}

        const rect = el.getBoundingClientRect()
        const bottomSpacing = 12
        const availableHeight = window.innerHeight - rect.top - bottomSpacing

        this.workshopBodyHeight = Math.max(availableHeight, 400)
      })
    },
    toggleInfos() {
      this.showInfos = !this.showInfos
    },
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
  user-select: none;
}
::v-deep .selected-row {
  background-color: #e3f2fd !important;
}

.workshop-header {
  border-radius: 4px;
  min-height: 6em;
}
.workshop-comment {
  white-space: pre-line;
  max-height: 4.5em;
  overflow-y: auto;
  line-height: 1.5em;
}

.workshop-body {
  height: 100%;
}


.panel-left {
  width: 30%;
  height: 100%;
  min-height: 0;
}
.meet-list-card {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.meet-list-table-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
.table {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 4px;
}

.panel-right {
  width: 69%;
  height: 100%;
  min-height: 0;
}
.contact-list-card {
  flex: 1 1 auto;
  min-height: 0;
}
.meet-contacts-list-grow {
  flex: 1 1 auto;
  min-height: 0;
}

.h-100 {
  height: 100%
}



</style>